// extracted by mini-css-extract-plugin
export default {"header":"OrdersDashboard_header__bWWnA"};